export function getCorrectWord(number, declinations) {
    // Приводим число к положительному и берём остаток от деления на 100
    var n = Math.abs(number) % 100;
    var lastDigit = n % 10;
    // Если число в диапазоне от 11 до 19, используем третий вариант
    if (n >= 11 && n <= 19) {
        return declinations[2];
    }
    // Если последняя цифра 1, используем первый вариант
    if (lastDigit === 1) {
        return declinations[0];
    }
    // Если последняя цифра от 2 до 4, используем второй вариант
    if (lastDigit >= 2 && lastDigit <= 4) {
        return declinations[1];
    }
    // В остальных случаях используем третий вариант
    return declinations[2];
}
